import { createSlice } from "@reduxjs/toolkit";

const initialAppsState = {
  actionsLoading: false,
  actionsLoadingMore: false,
  data: [],
};

const initialAppState = {
  actionsLoading: false,
  data: {},
};

const initialCategoriesState = {
  actionsLoading: false,
  data: [],
};

const initialAccountState = {
  actionsLoading: false,
  data: {},
};

const initialSettingsState = {
  actionsLoading: false,
  data: [],
};
const initialSearchState = {
  actionsLoading: false,
  actionsLoadingMore: false,
  data: [],
};

export const appsSlice = createSlice({
  name: "apps",
  initialState: initialAppsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      state.actionsLoading = false;
      state.actionsLoadingMore = false;
    },
    startCall: (state, action) => {
      state.error = null;
      state.actionsLoading = true;
      state.actionsLoadingMore = false;
    },
    startCallMore: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.actionsLoadingMore = true;
    },
    appsFetched: (state, action) => {
      const { data } = action.payload;
      state.actionsLoading = false;
      state.actionsLoadingMore = false;
      state.error = null;
      state.data = data;
    },
  }
});

export const appSlice = createSlice({
  name: "app",
  initialState: initialAppState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      state.actionsLoading = false;
    },
    startCall: (state, action) => {
      state.error = null;
      state.actionsLoading = true;
    },
    appFetched: (state, action) => {
      const { data } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.data = data;
    },
  }
});

export const categoriesSlice = createSlice({
  name: "categories",
  initialState: initialCategoriesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      state.actionsLoading = false;
    },
    startCall: (state, action) => {
      state.error = null;
      state.actionsLoading = true;
    },
    categoriesFetched: (state, action) => {
      const { data } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.data = data;
    },
  }
});

export const accountSlice = createSlice({
  name: "account",
  initialState: initialAccountState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      state.actionsLoading = false;
    },
    startCall: (state, action) => {
      state.error = null;
      state.actionsLoading = true;
    },
    accountFetched: (state, action) => {
      const { data } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.data = data;
    },
  }
});

export const settingsSlice = createSlice({
  name: "settings",
  initialState: initialSettingsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      state.actionsLoading = false;
    },
    startCall: (state, action) => {
      state.error = null;
      state.actionsLoading = true;
    },
    settingsFetched: (state, action) => {
      const { data } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.data = data;
    },
  }
});

export const searchSlice = createSlice({
  name: "search",
  initialState: initialSearchState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      state.actionsLoading = false;
      state.actionsLoadingMore = false;
    },
    startCall: (state, action) => {
      state.error = null;
      state.actionsLoading = true;
      state.actionsLoadingMore = false;
    },
    startCallMore: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.actionsLoadingMore = true;
    },
    dataFetched: (state, action) => {
      const { data } = action.payload;
      state.actionsLoading = false;
      state.actionsLoadingMore = false;
      state.error = null;
      state.data = data;
    },
  }
});